import React, { useEffect } from 'react';
import { get } from 'lodash-es';
import './ExpansionPanelBlock.scss';
import PropTypes from 'prop-types';
import useReducer from '../../Utils/useReducer';
import reducer from './ExpansionPanelBlock.reducer';
import { initializeState } from './ExpansionPanelBlock.transform';
import * as types from './ExpansionPanelBlock.actionTypes';
import Summary from './Blocks/Summary';
import Details from './Blocks/Details';
import {
  objectExpansionPanelShape,
  styleExpansionPanelShape,
  objectExpansionPanelDefault,
  styleExpansionPanelDefault,
} from './ExpansionPanelBlock.shape';
import { getLabel } from '../../Utils/utils';

/**
 *
 * @param {*} props
 */
const ExpansionPanelBlock = ({ objectExpansionPanel, styleExpansionPanel, eventEmitter, strings, children }) => {
  const initialState = initializeState({ list: objectExpansionPanel });
  const [state, dispatch] = useReducer(reducer, initialState);
  const [expansionPanelSummary, expansionPanelDetails] = children;

  useEffect(() => {
    dispatch({
      type: types.UPDATE,
      data: objectExpansionPanel,
    });
  }, [objectExpansionPanel]);

  useEffect(() => {
    // Add noDispatch to not dispatch an event if state have been updated from props
    if (!state.noDispatch) eventEmitter(state);
  }, [state]);

  /**
   * handle click event
   * @param {*} id
   */
  const handleClick = () => {
    dispatch({
      type: types.SET_EXPANDED,
    });
  };

  return (
    <div className={`expansionPanel-block-6a9-064f417-50f4-00f8-4e7b ${objectExpansionPanel?.code}`}>
      <Summary
        style={styleExpansionPanel}
        expansionPanelSummary={expansionPanelSummary}
        title={getLabel({
          label: state?.title,
          strings,
          defaultString: '',
        })}
        isCollapsed={!get(state, 'expanded')}
        disabled={get(state, 'disabled')}
        handleClick={handleClick}
      />
      <Details expansionPanelDetails={expansionPanelDetails} isCollapsed={!get(state, 'expanded')} />
    </div>
  );
};

ExpansionPanelBlock.propTypes = {
  objectExpansionPanel: objectExpansionPanelShape,
  styleExpansionPanel: styleExpansionPanelShape,
  eventEmitter: PropTypes.func,
  strings: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
};

ExpansionPanelBlock.defaultProps = {
  objectExpansionPanel: objectExpansionPanelDefault,
  styleExpansionPanel: styleExpansionPanelDefault,
  eventEmitter: () => {},
  strings: {},
  children: [<div key="1" />, <div key="2" />],
};

export default ExpansionPanelBlock;
